// 统一判断某个事件是否允许进入监控系统。
// 目前只识别通用协议字段，避免把具体业务码耦合进 core 层。
export const isMonitorReportable = (payload) => {
  if (!payload) {
    return true
  }

  return payload.__reportable !== false
}
